import { render, staticRenderFns } from "./RoleSummaryPanel.vue?vue&type=template&id=35404584&"
import script from "./RoleSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./RoleSummaryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports